// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"3e314373","439":"3e314373","979":"3e314373"}[chunkId] + ".chunk.css";
};